export default [
    {
        path: '/traffic-sources',
        name: 'PageTrafficSourcesList',
        meta: { title: 'trafficSources.listTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/traffic-sources'),
    },
    {
        path: '/traffic-sources/create',
        name: 'PageTrafficSourcesCreate',
        meta: { title: 'trafficSources.createFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/traffic-sources/create'),
    },
    {
        path: '/traffic-sources/:id/edit',
        name: 'PageTrafficSourcesEdit',
        meta: { title: 'trafficSources.editFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/traffic-sources/id/edit'),
    },
]
